import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['source', 'button']
  static values = { successText: String }

  copy() {
    const text = this.sourceTarget.textContent;
    navigator.clipboard.writeText(text.trim());

    this.buttonTarget.dataset.bsOriginalTitle = this.successTextValue;
    this.toggleTooltip();
  }

  toggleTooltip() {
    this.tooltip = bootstrap.Tooltip.getInstance(this.buttonTarget);
    this.tooltip.show();
    setTimeout(() => {
      this.tooltip.hide();
    }, 2000);
  }
}
